export const habaAddressBook = {
  habaAddressBook : {
    isDefaultDeliveryAddress: 'Standard Lieferadresse',
    isBillingAddress:'Entspricht Rechnungsaddresse',
    headline : 'Adressbuch',
    addNewAddress: 'Neue Adresse hinzufügen',
    updateAddress: 'Übernehmen',
    deleteAddress: 'Löschen',
    phoneLabel: 'Tel.:',
    msg : {
      updateAddress : 'Adresse übernommen'
    },
    subHeadline: 'Neue Adresse hinzufügen'
  }
};
